import { Icon } from '@phosphor-icons/react';
import { AnimatedNumber, AnimatedDuration } from '@/components/AnimatedNumber';

interface SummaryCardProps {
    icon: Icon;
    title: string;
    value: number;
    subtitle?: { value: number; suffix?: string; prefix?: string } | string;
    suffix?: string;
    isDuration?: boolean;
}

export function SummaryCard({
    icon: IconComponent,
    title,
    value,
    subtitle,
    suffix,
    isDuration = false,
}: SummaryCardProps) {
    return (
        <div className="bg-transparent border border-grey-600 rounded-[10px] p-4 flex flex-col items-start gap-4">
            <div className="flex items-center gap-1">
                <IconComponent className="size-[14px] text-grey-200" />
                <span className="text-sm text-grey-200 leading-5">{title}</span>
            </div>

            <div className="text-lg text-white leading-[28px]">
                {isDuration ? (
                    <AnimatedDuration totalSeconds={value} willChange />
                ) : (
                    <AnimatedNumber value={value} suffix={suffix} willChange />
                )}
            </div>

            {subtitle && (
                <div className="text-xs text-grey-300 leading-[18px]">
                    {typeof subtitle === 'string' ? (
                        subtitle
                    ) : (
                        <>
                            {subtitle.prefix && <span>{subtitle.prefix}</span>}
                            <AnimatedNumber value={subtitle.value} />
                            {subtitle.suffix && <span>{subtitle.suffix}</span>}
                        </>
                    )}
                </div>
            )}
        </div>
    );
}
